// extracted by mini-css-extract-plugin
module.exports = {"label":"dropdown_label__1g1mI","input-group":"dropdown_input-group__nks9D"};